import { msalInstance } from '../../auth/config'

export const useUser = () => {
  const account = msalInstance.getActiveAccount()

  const [firstName, lastName] = getFirstLastName(account?.name)
  const email = account?.username || ''

  return {
    pk: 1,
    id: 1,
    firstName,
    lastName,
    email,
  }
}

const getFirstLastName = (name?: string): [string, string] => {
  if (!name) return ['', '']

  const parts = name.split(' ')

  if (parts.length === 0) return ['', '']

  const firstName = parts[0]
  const lastName = parts.slice(1).join(' ')

  return [firstName, lastName]
}
